module.exports = __webpack_public_path__ + "fonts/MyriadPro-Semibold.662f360.OTF";